/**
 * SPECIFIC COMMON DIALOGS
 */
import $ from 'jquery';
import { hideDialog, initDialog, showDialog } from "stdjs/dialog-core";

export { hideDialog, initDialog, showDialog } from "stdjs/dialog-core"; 

export function setBodyContent( $dialog, $content ){
    $dialog = $( $dialog );
    $dialog.find( ".dialog-body" ).html( $content );
}

export function showConfirmDeleteDialog( deleteCallback, dialogSelector = null ){
    
    if ( dialogSelector === null ){
        dialogSelector = "#confirm-delete-dialog";
    }
    
    initDialog( dialogSelector );
    
    var $dialog = $( dialogSelector );
    
    var $deleteButton = $dialog.find( '.dialog-delete-button' );
    $deleteButton.off( 'click.confirm-delete-dialog' );
    $deleteButton.on( 'click.confirm-delete-dialog', function(){
        deleteCallback();
    });
    
    showDialog( dialogSelector );
    
    return $dialog;
    
}

export function hideConfirmDeleteDialog( dialogSelector = null ){
    if ( dialogSelector === null ){
        dialogSelector = "#confirm-delete-dialog";
    }
    
    hideDialog( dialogSelector );
}

export function showConfirmDialog( dialogSelector, confirmCallback = null ){
    var $dialog = $( dialogSelector );
    var dialogId = $dialog.attr( 'id' );
    
    initDialog( dialogSelector );
    
    // TODO take these from constants passed through to js??
    
    var $confirmButton = $dialog.find( '.confirm-dialog-confirm' );
    $confirmButton.off( 'click.confirm-dialog' );
    $confirmButton.on( 'click.confirm-dialog', function(){
        if ( $dialog.attr( 'close-on-confirm' ) === "1" ){
            hideDialog( $dialog );
        }
        
        if ( confirmCallback ){
            confirmCallback();
        }
    });
    
    showDialog( $dialog );
    
    return $dialog;
}

function integrationDialog(integrationsJson, integrationsType, dialogWidth, dialogTitle, dialogID, confirmCallback) {
    
    if ( typeof confirmCallback !== "function" ){
        confirmCallback = null;
    }
    
    /* If the integrations SME Professional/APR and Integration Types APPOINTMENT set bop_active to 0 as SME/APR does not cover appointments */
    if(integrationsType=="APPOINTMENT" && ( integrationsJson["PROVIDER"]=="SME Professional" || integrationsJson["PROVIDER"]=="APR" )) {
        integrationsJson["BOP_ACTIVE"] = 0;
        if ( confirmCallback ){
            confirmCallback();
            return false;
        }
        schedulerDialog();
    }
    
    if(integrationsJson["BOP_ACTIVE"]) {

        $("#"+dialogID+"Confirm").click(function(event) {
            
            if (confirmCallback){
                confirmCallback();
                $("#"+dialogID).dialog("destroy").remove();
                return false;
            }
            
            if(integrationsType=="PROPERTY") {
                location.href = "/property/create";
            } else {
               schedulerDialog();
            }
        });          
    }
}